import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  updateSchoolAwayDetails(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/away/management/update", payload).then(
      (res) => {
        return res;
      }
    );
  },
};

export default {
  actions,
};
